<div class="container">
    <h4>Your store provides the following:</h4>
    <mat-chip-listbox multiple class="container-content">
        <mat-chip *ngFor="let storeLocationOption of storeLocationOptionViewModel">{{storeLocationOption.viewValue}}</mat-chip>
    </mat-chip-listbox>
  </div>
  